import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import EmptyState from '../../../../../../components/EmptyState';
import AlertMessage from '../../../../../../components/AlertMessage';
import { getBigNumbers } from '../../../../../../redux/dashboard-completed';
import { getDashboardCompletedBigNumbersUI } from '../../../../../../redux/selectors';

import Comparative from './components/Comparative';

import './styles.css';
import DefaultCardItem, {
  CARD_COLOR,
} from '../../../../../../components/DefaultCardItem';
import FileSignature from '../../../../../../assets/images/file-signature.png';
import AttachMoney from '../../../../../../assets/images/attach_money.png';
import Weight from '../../../../../../assets/images/weight.png';
import { FormattedNumber } from 'react-intl';
import { CardsWrapper, ContentWrapper } from './styles';
import { SkeletonBigNumbers } from './components/Skeleton';

const BigNumbers = ({ shouldUsePeriodSelectDates, dispatch, data, ui }) => {
  const _getBigNumbers = () => {
    if (!shouldUsePeriodSelectDates) {
      dispatch(getBigNumbers());
    }
  };

  useEffect(() => {
    _getBigNumbers();
  }, []);

  if (!ui.isFetching && (!data || !data.nfQuantity)) {
    return (
      <div className="DashboardCompletedOverview__empty">
        <EmptyState
          className="DashboardCompletedOverview__empty-component"
          message="Não existem dados para os filtros selecionados"
        />
      </div>
    );
  }

  if (ui.error) {
    return (
      <div className="DashboardCompletedOverview__error">
        <AlertMessage
          error
          message={ui.error}
          actionText="Tentar novamente"
          onRetry={_getBigNumbers}
        />
      </div>
    );
  }

  return (
    <div className={`DashboardCompletedOverview`}>
      {ui.isFetching ? (
       <SkeletonBigNumbers />
      ) : (
        <ContentWrapper>
          <CardsWrapper>
            <div key="2" className="DashboardCompletedOverview__primary">
              <DefaultCardItem
                iconPath={FileSignature}
                title="Total de NFs"
                contentText={data.nfQuantity}
                secondContentText="NFs"
                color={CARD_COLOR.BLUE}
              />
            </div>
            <div key="2" className="DashboardCompletedOverview__primary">
              <DefaultCardItem
                iconPath={AttachMoney}
                title="Valor transportado"
                contentText={
                  <FormattedNumber
                    value={data.transportedTotalValueNf / 1000000}
                    style="currency"
                    currency="BRL"
                  />
                }
                secondContentText="MM"
                color={CARD_COLOR.GRAY}
              />
            </div>
            <div key="2" className="DashboardCompletedOverview__primary">
              <DefaultCardItem
                iconPath={Weight}
                title="Peso transportado"
                contentText={
                  <FormattedNumber
                    value={data.transportedWeightNF / 1000}
                    useGrouping
                    minimumFractionDigits={2}
                    maximumFractionDigits={2}
                  />
                }
                secondContentText="T"
                color={CARD_COLOR.GRAY}
              />
            </div>
            <div key="2" className="DashboardCompletedOverview__secondary">
              <Comparative
                className="DashboardCompletedOverview__comparative"
                earlyPc={data.comparativeEarly}
                onTimePc={data.comparativeOnTime}
                LatePc={data.comparativeLate}
                performanceOnTime={data.performanceOnTime}
                performanceLate={data.performanceLate}
                performanceEarly={data.performanceEarly}
              />
            </div>
          </CardsWrapper>
        </ContentWrapper>
      )}
    </div>
  );
};

// redux
const mapStateToProps = state => {
  return {
    data: state.dashboardCompleted.bigNumbers.data,
    ui: getDashboardCompletedBigNumbersUI(state),
  };
};

export default connect(mapStateToProps)(BigNumbers);
